"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSCXCampaign = void 0;
const utils_fetch_1 = __importDefault(require("@gcloud-npm/utils.fetch"));
const node_build_process_build_environments_1 = require("@gcloud-npm/node.build-process.build-environments");
const utils_enums_environment_1 = require("@gcloud-npm/utils.enums.environment");
const utils_monitoring_sonda_1 = __importDefault(require("@gcloud-npm/utils.monitoring.sonda"));
const utils_monitoring_get_uuid_1 = __importDefault(require("@gcloud-npm/utils.monitoring.get-uuid"));
const utils_adabyron_make_up_telco_path_name_1 = require("@gcloud-npm/utils.adabyron.make-up-telco-path-name");
const EVENT_NAME = "MISC.GET_SCX_CAMPAIGN";
function getSCXCampaign({ data, context: appContext, build = false, envName = `${process.env.NEXT_PUBLIC_ENV_NAME}`, idFront = "VT", }) {
    const myContext = Object.assign(Object.assign({}, appContext), { environment: (0, utils_enums_environment_1.findOutEnvByEnvName)(envName) });
    const { campaign: connectionData } = myContext.environment;
    const { endpoint: host } = connectionData;
    const URL_API = `${host}/scx/campaign/dispatcher/campaign`;
    // const URL_API = `https://campaign.scx.col.movistar.es/scx/campaign/dispatcher/campaign`;
    // const URL_API = `https://scx-campaign-dot-mov-dev9.ew.r.appspot.com/scx/campaign/dispatcher/campaign`;
    const idRequest = (0, utils_monitoring_get_uuid_1.default)(idFront);
    const headers2Use = (0, node_build_process_build_environments_1.calculateHeaderParams)(build, utils_enums_environment_1.FAMILY_API.CAMPAIGN, appContext);
    const sonda = new utils_monitoring_sonda_1.default({
        eventName: EVENT_NAME,
        context: myContext,
        uniqueId: idRequest,
        origin: utils_adabyron_make_up_telco_path_name_1.PROCESS_NAME.CLIENT,
    });
    const request = new utils_fetch_1.default({
        method: "POST",
        endpoint: URL_API,
        data,
        headers: Object.assign({}, headers2Use),
        sonda,
        responseType: "text",
    });
    return request.makeRequest();
}
exports.getSCXCampaign = getSCXCampaign;
exports.default = getSCXCampaign;
//# sourceMappingURL=index.js.map